import CondominiumsPublicListView from '../components/CondominiumsPublicListView';

export default function CondominiumsPublicList() {
  return <CondominiumsPublicListView />;
}
